const { hasThirdPartyInstallments } = require('../InstallmentList')

const getTitleScreenReader = (installments, stepTitle, translations) => hasThirdPartyInstallments(installments)
        ? translations.THIRD_PARTY_STEP_TITLE(stepTitle)
        : stepTitle

export {
    getTitleScreenReader,
}